import { busTimesMachine } from '@/features/bus-times/state/bus-times.machine';
import { defineFeature } from '@/lib/platform/system';
export const features = [
  defineFeature({
    id: 'bus-times',
    machine: busTimesMachine,
    emits: [],
    handles: [],
    accepts: [
      'bus-times.choose-route',
      'bus-times.choose-direction',
      'bus-times.choose-stop',
      'bus-times.view-schedule',
      'bus-times.refresh-schedule',
      'bus-times.recall-stop',
    ],
  }),
] as const;
